<template>
  <div class="aui-wrapper aui-page__login">
    <div class="aui-content__wrapper">
      <main class="aui-content">
        <div class="login-body">
          <div class="img-box">
            <el-image class="img" :src="loginImg" fit="contain"></el-image>
          </div>
          <div class="login-box">
            <h3 class="login-title">瑞佳源纺织云生产智慧平台 FZCLOUD<br/>{{ appName }}</h3>
            <el-form
                :model="dataForm"
                :rules="dataRule"
                ref="dataForm"
                @keyup.enter.native="dataFormSubmitHandle()"
                status-icon
            >
              <el-form-item v-show="false">
                <el-select v-model="$i18n.locale" class="w-percent-100">
                  <el-option
                      v-for="(val, key) in i18nMessages"
                      :key="key"
                      :label="val._lang"
                      :value="key"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="username">
                <el-input
                    v-model="dataForm.username"
                    :placeholder="$t('login.username')"
                >
                  <span slot="prefix" class="el-input__icon">
                    <svg class="icon-svg" aria-hidden="true">
                      <use xlink:href="#icon-user"></use>
                    </svg>
                  </span>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                    v-model="dataForm.password"
                    type="password"
                    :placeholder="$t('login.password')"
                >
                  <span slot="prefix" class="el-input__icon">
                    <svg class="icon-svg" aria-hidden="true">
                      <use xlink:href="#icon-lock"></use>
                    </svg>
                  </span>
                </el-input>
              </el-form-item>
              <el-form-item prop="captcha">
                <el-row :gutter="20">
                  <el-col :span="14">
                    <el-input
                        v-model="dataForm.captcha"
                        :placeholder="$t('login.captcha')"
                    >
                      <span slot="prefix" class="el-input__icon">
                        <svg class="icon-svg" aria-hidden="true">
                          <use xlink:href="#icon-safetycertificate"></use>
                        </svg>
                      </span>
                    </el-input>
                  </el-col>
                  <el-col :span="10" class="login-captcha">
                    <img :src="captchaPath" @click="getCaptcha()"/>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item>
                <el-button
                    :disabled="isWeixin"
                    type="primary"
                    @click="dataFormSubmitHandle()"
                    class="w-percent-100"
                >{{ $t('login.title') }}
                </el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import debounce from 'lodash/debounce'
import { messages } from '@/i18n'
import { getUUID } from '@/utils'

export default {
  data () {
    return {
      i18nMessages: messages,
      captchaPath: '',
      appName: window.SITE_CONFIG['AppName'],
      loginImg: require('@/assets/img/login-img.png'),
      dataForm: {
        username: '',
        password: '',
        uuid: '',
        captcha: '',
      },
    }
  },
  computed: {
    isWeixin () {
      if (!navigator.userAgent) {
        return
      }
      var ua = navigator.userAgent.toLowerCase() //获取判断⽤的对象
      return ua.match(/MicroMessenger/i) == 'micromessenger'
    },
    dataRule () {
      return {
        username: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
        ],
        captcha: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'blur',
          },
        ],
      }
    },
  },
  mounted () {
    this.getCaptcha()
    this.checkLoginStatus()
  },
  methods: {
    checkLoginStatus () {
      this.$http.get(`/sys/user/info`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$router.replace({ name: 'home' })
      }).catch(e => {
        console.log(e)
      })

    },
    // 获取验证码
    getCaptcha () {
      this.dataForm.uuid = getUUID()
      this.captchaPath = `${window.SITE_CONFIG['apiURL']}/captcha?uuid=${this.dataForm.uuid}`
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
        function () {
          this.$refs['dataForm'].validate((valid) => {
            if (!valid) {
              return false
            }
            this.$http
                .post('/login', this.dataForm)
                .then(({ data: res }) => {
                  if (res.code !== 0) {
                    this.getCaptcha()
                    return this.$message.error(res.msg)
                  }
                  Cookies.set('token', res.data.token)
                  this.$router.replace({ name: 'home' })
                })
                .catch(() => {
                })
          })
        },
        1000,
        { leading: true, trailing: false }
    ),
  },

}
</script>

<style lang="scss" scoped>
// .aui-wrapper .el-input__prefix .el-input__icon{
//   margin-top:12px;
// }
.login-body {
  border-radius: 20px;
  padding: 30px;
  display: flex;
  align-items: center;
  width: auto;

  .img-box {
    width: 300px;
    height: 300px;

    .img {
      width: 100%;
      height: 100%;
    }
  }

  .login-box {
    width: 300px;
    margin-left: 30px;

    .login-title {
      font-size: 24px;
      font-family: SourceHanSansSC;
      font-weight: 500;
      color: #333333;
    }
  }
}
</style>
